/**
 * Datas sem hora, como a pessoa digita e como a API as transporta (RT-21): "dd/mm/aaaa" na tela,
 * "aaaa-mm-dd" no contrato, sem passar por fuso. O que tem hora usa `formatRelative`/`formatDate`
 * de `@westhetics/ui`.
 */

/** "15021993" → "15/02/1993" (aceita entrada parcial durante a digitação). */
export function maskDate(text: string) {
  const digits = text.replace(/\D/g, '').slice(0, 8)
  if (digits.length <= 2) return digits
  if (digits.length <= 4) return `${digits.slice(0, 2)}/${digits.slice(2)}`
  return `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}`
}

/** "dd/mm/aaaa" → "aaaa-mm-dd"; `null` quando a data não existe. */
export function brDateToIso(text: string): string | null {
  const match = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(text.trim())
  if (!match) return null
  const [, dd, mm, yyyy] = match
  const date = new Date(Date.UTC(Number(yyyy), Number(mm) - 1, Number(dd)))
  const exists =
    date.getUTCFullYear() === Number(yyyy) &&
    date.getUTCMonth() === Number(mm) - 1 &&
    date.getUTCDate() === Number(dd)
  return exists ? `${yyyy}-${mm}-${dd}` : null
}

/** "2024-03-12" → "12/03/2024", sem passar por fuso: a data não tem hora (RT-21). */
export function isoToBrDate(iso: string | null): string {
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso ?? '')
  return match ? `${match[3]}/${match[2]}/${match[1]}` : ''
}

/** O dia de hoje em `aaaa-mm-dd`, no relógio de quem usa. */
export function todayIso(now: Date = new Date()) {
  const pad = (n: number) => String(n).padStart(2, '0')
  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`
}
